var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:_vm.labelClass},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.onChange()}}}),_c('div',{class:_vm.iconClass}),(_vm.hasSlot)?_c('div',{class:_vm.wrapperClass},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }